import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentSelectedTab: "Matches",
};

export const homeSlice = createSlice({
  name: "homeSlice",
  initialState: initialState,
  reducers: {
    setCurrentSelectedTab: (state, action) => {
      state.currentSelectedTab = action.payload;
    },
  },
});

export const { setCurrentSelectedTab } = homeSlice.actions;
export default homeSlice.reducer;
